import { createClient } from "contentful";
// constant for contentful environment handling
export const CONTENTFUL_MASTER = "master";
export const CONTENTFUL_QUALIFICATION = "qualification";
export const CONTENTFUL_DEV = "dev";
function contentfulEnvironmentName(environmentName) {
    switch (environmentName) {
        case "PRD":
        case "TEST":
            return CONTENTFUL_MASTER;
        case "QUA":
            return CONTENTFUL_QUALIFICATION;
        case "UMG-TMP":
            return "umg-tmp";
        default:
            return CONTENTFUL_DEV;
    }
}
class ContentfulClient {
    constructor({ contentfulSpaceId, contentfulApiKey, environmentName, }) {
        this.contentfulSpaceId = contentfulSpaceId;
        this.contentfulApiKey = contentfulApiKey;
        this.contentfulEnvironment = contentfulEnvironmentName(environmentName);
    }
    get api() {
        return createClient({
            space: this.contentfulSpaceId,
            accessToken: this.contentfulApiKey,
            environment: this.contentfulEnvironment,
        });
    }
}
export default ContentfulClient;
//# sourceMappingURL=index.js.map